import React, { useState, useEffect } from 'react';
import { Row, Col, Card, Button, Badge } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import api from '../../../api/apiClient';
import { toast } from 'react-toastify';

const AvailableSurveys = () => {
  const navigate = useNavigate();
  const [surveys, setSurveys] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchAvailableSurveys();
  }, []);

  const fetchAvailableSurveys = async () => {
    try {
      const response = await api.surveys.getAvailable();
      setSurveys(response.data.data || []);
    } catch (error) {
      console.error('Error fetching surveys:', error);
      toast.error('Failed to load surveys');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-purple-50 via-white to-indigo-50 flex items-center justify-center p-4">
        <div className="text-center">
          <div className="inline-block animate-spin rounded-full h-16 w-16 border-4 border-purple-600 border-t-transparent mb-4"></div>
          <p className="text-gray-600 text-lg font-medium">Loading surveys...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-50 via-white to-indigo-50 p-4 sm:p-6 md:p-8 lg:p-10">
      {/* Header */}
      <div className="mb-6 sm:mb-8">
        <div className="bg-white/90 backdrop-blur-sm rounded-2xl sm:rounded-3xl px-5 py-4 sm:p-6 border border-purple-100 shadow-xl">
          <div className="flex items-center gap-4">
            <div className="w-12 h-12 sm:w-14 sm:h-14 bg-gradient-to-br from-pink-500 to-rose-600 rounded-xl sm:rounded-2xl flex items-center justify-center text-white text-xl sm:text-2xl shadow-md">
              <i className="fas fa-poll"></i>
            </div>
            <div>
              <h2 className="text-left text-2xl sm:text-2xl font-bold text-gray-900 mb-1">Available Surveys</h2>
              <p className="text-gray-600 text-sm sm:text-base m-0">
                Complete surveys to provide your feedback
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="bg-white/90 backdrop-blur-sm rounded-2xl sm:rounded-3xl border border-purple-100 shadow-xl p-4 sm:p-6">
        {surveys.length === 0 ? (
          <div className="text-center py-12 sm:py-16">
            <div className="w-20 h-20 sm:w-24 sm:h-24 bg-gradient-to-br from-pink-400 to-rose-500 rounded-full flex items-center justify-center mx-auto mb-4 shadow-lg">
              <i className="fas fa-poll text-white text-3xl sm:text-3xl"></i>
            </div>
            <h4 className="text-xl sm:text-2xl font-bold text-gray-900 mb-2">No Surveys Available</h4>
            <p className="text-gray-600 text-base sm:text-lg">There are no surveys available for you at this time.</p>
          </div>
        ) : (
          <Row className="g-4">
            {surveys.map((survey) => (
              <Col key={survey.id} md={6} lg={4} sm={12}>
                <Card className="h-100 border-0 shadow-lg hover:shadow-2xl transition-all duration-300 hover:scale-105" style={{ borderRadius: '16px', overflow: 'hidden' }}>
                  {survey.image_path && (
                    <div style={{ height: '200px', overflow: 'hidden' }}>
                      <Card.Img 
                        variant="top" 
                        src={`${process.env.REACT_APP_API_BASE_URL?.replace('/api', '')}${survey.image_path}`}
                        style={{ height: '100%', objectFit: 'cover', transition: 'transform 0.3s ease' }}
                        onMouseEnter={(e) => e.target.style.transform = 'scale(1.05)'}
                        onMouseLeave={(e) => e.target.style.transform = 'scale(1)'}
                      />
                    </div>
                  )}
                  <Card.Body className="d-flex flex-column p-4">
                    <div className="mb-3">
                      <Badge className={`px-3 py-1 rounded-full font-semibold ${
                        survey.survey_type === 'global' 
                          ? 'bg-gradient-to-r from-blue-500 to-cyan-600 text-white' 
                          : 'bg-gradient-to-r from-indigo-500 to-purple-600 text-white'
                      }`}>
                        {survey.survey_type === 'global' ? 'Global' : 'Organization'}
                      </Badge>
                    </div>
                    <Card.Title className="fw-bold text-gray-900 mb-2">{survey.title}</Card.Title>
                    <Card.Text className="text-gray-600 flex-grow-1 mb-3" style={{
                      display: '-webkit-box',
                      WebkitLineClamp: 3,
                      WebkitBoxOrient: 'vertical',
                      overflow: 'hidden',
                      minHeight: '60px'
                    }}>
                      {survey.description || 'No description available'}
                    </Card.Text>
                    <div className="d-flex justify-content-between align-items-center mt-auto">
                      <small className="text-gray-600 d-flex align-items-center">
                        <i className="fas fa-question-circle me-1 text-purple-600"></i>
                        <span className="font-semibold">{survey.question_count || 0} questions</span>
                      </small>
                      <Button 
                        bsPrefix="custom-hamburger"
                        className="border-1 border-purple-600 bg-white text-purple-600 hover:from-purple-700 hover:to-pink-700 font-semibold rounded-lg sm:rounded-xl shadow-md hover:shadow-lg transition-all duration-200 text-xs sm:text-sm h-full flex items-center justify-center gap-2 p-2"
                     
                        size="sm"
                        onClick={() => navigate(`/user/surveys/${survey.id}/respond`)}
                      >
                        Take Survey
                        <i className="fas fa-arrow-right ms-2"></i>
                      </Button>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        )}
      </div>
    </div>
  );
};

export default AvailableSurveys;
